import { render, staticRenderFns } from "./phone4.vue?vue&type=template&id=9bae2d06&scoped=true&"
var script = {}
import style0 from "./phone4.vue?vue&type=style&index=0&id=9bae2d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae2d06",
  null
  
)

export default component.exports